import OmegaRepository from '@/_shared/repositories/omega.respository';
import Rep from '@/_shared/entities/rep/rep.entity';

class MyProfileService {
  private omegaRepository: OmegaRepository = new OmegaRepository();

  public changePreferredLanguage(rep: Rep, language: number) {
    const formData = this.createContactInfoFormData(rep, language);
    return this.omegaRepository.post(`/rep/${rep.did}/profile`, formData);
  }

  private createContactInfoFormData(rep: Rep, language: number) {
    const billing = {
      street: rep.billing.street,
      city: rep.billing.city,
      state: rep.billing.state,
      postal: rep.billing.postal,
      county: rep.billing.county,
    };

    const shipping = {
      street: rep.shipping.street,
      city: rep.shipping.city,
      state: rep.shipping.state,
      postal: rep.shipping.postal,
      county: rep.shipping.county,
    };

    return {
      email: rep.email,
      phone: [
        rep.phone.home,
        rep.phone.work,
      ],
      language,
      billing,
      shipping,
    };
  }

  /* eslint-disable @typescript-eslint/camelcase */
  public changeRecognitionName(repDid: number, recognitionName: string) {
    const formData = {
      recognition_name: recognitionName,
    };

    return this.omegaRepository.post(`/rep/${repDid}/recognition`, formData);
  }

  public changeRecognitionPicture(repDid: number, formData: FormData) {
    return this.omegaRepository.post(`/rep/${repDid}/pictures/recognition`, formData);
  }

  public getRecognitionPictureApprovalState(repDid: number): Promise<{ approved: number }> {
    return this.omegaRepository.get(`/rep/${repDid}/pictures/recognition`, { withCredentials: true })
      .then((response) => response.data);
  }
}

export default new MyProfileService();
